import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
    selector: 'app-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.css'],
    standalone: false
})
export class SearchInputComponent {
  @Output() onValueChange = new EventEmitter<string>();
  @Input() searchValue: string = '';
  constructor(private cd: ChangeDetectorRef) {}

  applyFilter(): void {
    this.onValueChange.next(this.searchValue);
    this.cd.detectChanges();
  }
  clear(): void {
    this.searchValue = '';
    this.applyFilter();
  }
}
